import React, { useEffect, useState } from 'react';
import {
  Button,
  FormField,
  Header,
  Multiselect,
  MultiselectProps,
  SpaceBetween,
  AutosuggestProps,
  NonCancelableCustomEvent,
} from '@amzn/awsui-components-core';
import {
  ContentUserRole,
  TechDomain,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';
import constants from '../../../common/constants';
import ContentUserRoleGroup from './ContentUserRoleGroup';

class UserRoleMultiSelectProps {
  // @ts-expect-error TS2564 - strict migration
  sequenceId: number;
  // @ts-expect-error TS2564 - strict migration
  roleGroup: ContentUserRoleGroup;
  // @ts-expect-error TS2564 - strict migration
  onSelectedRolesUpdated: (selectedRoles: ContentUserRoleGroup) => void;
  // @ts-expect-error TS2564 - strict migration
  onRoleDefinitionDeleted: (groupId: string) => void;
}

export function ContentUserRoleMultiSelect(props: UserRoleMultiSelectProps) {
  const options: AutosuggestProps.Option[] = [
    { value: ContentUserRole.BarRaiser, label: constants.USER_ROLES_BAR_RAISER },
  ];

  const technologyOptions: AutosuggestProps.Option[] = Array.from(TechDomainDisplayNames.entries())
    .map((e) => {
      return { value: e[0], label: e[1] };
    })
    .sort((a, b) => {
      const al = a.label.toLowerCase();
      const bl = b.label.toLowerCase();
      if (al > bl) {
        return 1;
      }
      if (al < bl) {
        return -1;
      }
      return 0;
    });

  const [selectedRoleOptions, setSelectedOptions] = useState<readonly AutosuggestProps.Option[]>(
    options.filter((o) => props.roleGroup.roles.some((r) => r === o.value)),
  );
  const [selectedTechnologyOptions, setSelectedTechnologyOptions] = useState<
    readonly AutosuggestProps.Option[]
  >(technologyOptions.filter((o) => props.roleGroup.technologies.some((t) => t === o.value)));

  const handleSelectionChange = (
    event: NonCancelableCustomEvent<MultiselectProps.MultiselectChangeDetail>,
  ) => {
    setSelectedOptions(event.detail.selectedOptions);
  };

  const handleTechnologySelectionChange = (
    event: NonCancelableCustomEvent<MultiselectProps.MultiselectChangeDetail>,
  ) => {
    setSelectedTechnologyOptions(event.detail.selectedOptions);
  };

  useEffect(() => {
    const grp: ContentUserRoleGroup = {
      groupId: props.roleGroup.groupId,
      roles: selectedRoleOptions.map(
        (o) => ContentUserRole[o.value as keyof typeof ContentUserRole],
      ),
      technologies: selectedTechnologyOptions.map(
        (o) => TechDomain[o.value as keyof typeof TechDomain],
      ),
    };
    props.onSelectedRolesUpdated(grp);
  }, [selectedRoleOptions, selectedTechnologyOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const deleteRoleDefinition = () => {
    props.onRoleDefinitionDeleted(props.roleGroup.groupId);
  };

  return (
    <>
      <Header
        variant="h3"
        actions={
          <Button iconName="close" onClick={deleteRoleDefinition}>
            Remove
          </Button>
        }
      >
        {constants.USER_PERMISSION_MGMT_CONTENT_USER_ROLES_ITEM_HEADER} {props.sequenceId}:
      </Header>
      <SpaceBetween size="m">
        <FormField
          label={constants.USER_PERMISSION_MGMT_CONTENT_USER_ROLES_LABEL}
          description={constants.USER_PERMISSION_MGMT_CONTENT_USER_ROLES_DESC}
        >
          <Multiselect
            options={options}
            selectedOptions={selectedRoleOptions}
            onChange={handleSelectionChange}
            deselectAriaLabel={() => 'Remove role'}
            ariaRequired
          />
        </FormField>
        <FormField
          label={constants.USER_PERMISSION_MGMT_CONTENT_USER_ROLES_TECH_FILTER_LABEL}
          description={constants.USER_PERMISSION_MGMT_CONTENT_USER_ROLES_TECH_FILTER_DESC}
        >
          <Multiselect
            options={technologyOptions}
            selectedOptions={selectedTechnologyOptions}
            disabled={selectedRoleOptions.length < 1}
            onChange={handleTechnologySelectionChange}
            deselectAriaLabel={() => 'Remove technology'}
            ariaRequired
          />
        </FormField>
      </SpaceBetween>
    </>
  );
}
